<template>
  <div id="app">
    <div class="header">
      <router-link to="/" class="header__title">
        note todo
      </router-link>
    </div>

    <router-view/>
  </div>
</template>

<script>
export default {
  created() {
    this.$store.dispatch('fetchNotes')
  }
}
</script>

<style lang="stylus" scoped>
@import './css/vars.styl'
@import './css/mixins.styl'

#app
  padding 0 16px 40px

.header
  padding 40px 0 24px

  &__title
    font-size 60px
    user-select none
    cursor pointer
    color $white
    text-decoration none
    hover()

</style>
